export const defaultState = {
  basicProfile: null,
  practiceCenters: null,
  slots: null,
  education: null,
  experience: null,
  awards: null,
  fulfilment: null,
  membership: null,
  registrations: null,
  services: null,
  specializations: null
};

export default function doctorProfile(state = defaultState, action) {
  switch (action.type) {
    case 'SET_PROFILE':
      return Object.assign(
        {},
        {
          ...state,
          ...action.payload
        }
      );
    default:
      return state;
  }
}
